import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-property-tax-form-editor',
  templateUrl: './property-tax-form-editor.component.html',
  styleUrls: ['./property-tax-form-editor.component.css']
})
export class PropertyTaxFormEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
